import { createContext, useCallback, useContext, useRef, useState } from "react";
import { AlertText } from "../components/Alert/AlertText";

// Global toast host: actions that remove their own component from the tree
// (delete bookmark/collection) can't render an AlertText themselves — it
// would unmount with them. showToast() hands the message to this provider,
// which outlives them.
const ToastContext = createContext(() => {});

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(0);

  const showToast = useCallback(
    ({ message, title, variant = "success", duration = 4000 }) => {
      const id = ++nextId.current;
      setToasts((prev) => [...prev, { id, message, title, variant, duration }]);
    },
    []
  );

  const removeToast = (id) =>
    setToasts((prev) => prev.filter((toast) => toast.id !== id));

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      {toasts.map(({ id, ...toast }) => (
        <AlertText key={id} {...toast} onRemove={() => removeToast(id)} />
      ))}
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
